module.exports = __webpack_public_path__ + "static/media/exhibition-services-img3.6b55c830.jpg";